import { styled } from '@mui/material';

export const Container = styled('div')(
  ({ templateConfig }: { templateConfig: string }) => ({
    display: 'grid',
    gridTemplateColumns: templateConfig,
    gridTemplateRows: '1fr',
    height: '100%',
    gap: 24,
    padding: '12px 24px 24px',
    overflow: 'hidden',
  })
);

export const Main = styled('section')(
  ({ isFilter, isDetail }: { isFilter: boolean; isDetail: boolean }) => ({
    overflow: 'hidden',
    position: 'relative',
    gridColumn: `${!isFilter ? 1 : 2} / ${isDetail ? 3 : 4}`,
    gridRow: '1 / 2',
  })
);

export const Detail = styled('section')(() => ({
  position: 'relative',
}));
